var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.cof.js
 **/